import { Box, Card, Grid, Tab, Tabs, Typography, useTheme } from "@mui/material"
import { useState, useEffect } from "react"
import TabTicketsScreen from "./TabTicketsScreen";
import TabConsultasScreen from "./TabConsultasScreen";
import TabPreServiciosScreen from "./TabPreServiciosScreen";

function TabPanel({ children, value, index, ...other }) {
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
            style={{maxHeight:'70vh', overflow: 'auto'}}
            className='side'
        >
        {value === index && (
            <Box sx={{ p: 3 }}>{children}</Box>
        )}
        </div>
    );
}
function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const AnaliticsGralScreen = () => {
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === 'dark';
    const [value, setValue] = useState(0);
    useEffect(() => {
        document.title = `Analitica - General`;
    }, [])
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    return (
        <Box sx={{width:'100%',height: '100%',overflow:'auto', background: isDarkMode ? '#1a2332' : '#f5f5f5'}} className='side'>
            <Grid container p={3} mb={1}>
                <Grid item xs={12}>
                    <Typography sx={{color: isDarkMode ? '#e0e0e0' : '#000', fontWeight: 'bold'}} variant="h3">Analítica General</Typography>
                </Grid>
                <Grid item xs={12}>
                    <Card sx={{background: isDarkMode ? '#2d3a52 !important' : '#fff !important',p:2,borderRadius:4}}>
                        <Box sx={{ borderBottom: 1, borderColor: isDarkMode ? '#3d4a62' : '#6b788e' }}>
                            <Tabs
                                value={value}
                                onChange={handleChange}
                                aria-label="basic tabs example"
                                variant="scrollable"
                                sx={{
                                    '& .MuiTabs-indicator':{
                                        background: '#0364ff'
                                    },
                                    '& .MuiButtonBase-root':{
                                    color: isDarkMode ? '#b0b0b0' : '#6b788e',
                                    fontWeight: 'bold'
                                    },
                                    '& .MuiButtonBase-root.Mui-selected':{
                                        color: '#0364ff'
                                    }
                                }}
                            >
                                <Tab label="Tickets" {...a11yProps(0)} sx={{ minWidth: "fit-content", flex: 1 }}/>
                                <Tab label="Consultas" {...a11yProps(1)} sx={{ minWidth: "fit-content", flex: 1 }}/>
                                <Tab label="Pre-Servicios" {...a11yProps(2)} sx={{ minWidth: "fit-content", flex: 1 }}/>
                            </Tabs>
                        </Box>
                        <TabPanel value={value} index={0}>
                            <TabTicketsScreen />
                        </TabPanel>
                        <TabPanel value={value} index={1}>
                            <TabConsultasScreen />
                        </TabPanel>
                        <TabPanel value={value} index={2}>
                            <TabPreServiciosScreen />
                        </TabPanel>
                    </Card>
                </Grid>
            </Grid>
        </Box>
    )
}

export default AnaliticsGralScreen;